// What the media queue owes an asset, and how far through it is.

import { api } from '../client'
import type { components } from '../schema'

export type AssetProcessingView = components['schemas']['AssetProcessingView']
export type AssetProcessingProgress = components['schemas']['AssetProcessingProgress']
export type ProcessingJobEntry = components['schemas']['ProcessingJobEntry']
export type ProcessingJobKind = components['schemas']['ProcessingJobKind']
export type ProcessingFailureCause = components['schemas']['ProcessingFailureCause']
export type ProcessingStep = components['schemas']['ProcessingStep']

/**
 * Every job this asset's media work has produced, newest first, and the one word for what is
 * happening now. Unpaginated — the list is bounded by the queue's own ninety-day retention.
 *
 * **This is where the step comes from.** `AssetView` carries no `processing_step`: a column would
 * have one writer per handler and they run at once, so it is derived here from the live rows. An
 * asset nothing ever asked work for answers an empty list, a `null` step and a `null` ratio.
 */
export function getAssetProcessing(assetId: string, signal?: AbortSignal): Promise<AssetProcessingView> {
  return api.get<AssetProcessingView>(`/assets/${encodeURIComponent(assetId)}/processing`, undefined, signal)
}
